import React from "react";
import { Form, Button, Input, message, Select } from "antd";
import { useTranslation } from "react-i18next";
import { apiClient } from "../Api/AllApi";
import "../Styles/AddProducts.css";

const AddCustomer = () => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const { Option } = Select;

  const onFinish = async (values) => {
    try {
      console.log("Submitting values:", values);
      const res = await apiClient.post("/customers", values);
      if (res.status === 200 || res.status === 201) {
        message.success(t("successMessage"));
        window.location.href = "/GetCustomer";
      } else {
        message.error(t("errorMessage"));
      }
    } catch (error) {
      console.error("Submit error:", error);
      message.error(t("errorMessage"));
    }
  };

  const layout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 16 },
  };

  return (
    <div style={{ textAlign: "center", marginTop: "50px", direction: "rtl" }}>
      <h1 style={{ fontSize: "24px", marginBottom: "20px" }}>
        {t("addCustomer")}
      </h1>

      <Form
        form={form}
        {...layout}
        onFinish={onFinish}
        style={{ fontSize: "18px" }}
      >
        <Form.Item
          name="name"
          label={<span style={{ fontSize: "18px", fontWeight: "bold" }}>{t("name")}</span>}
          rules={[{ required: true, message: t("pleaseEnterName") }]}
        >
          <Input
            style={{ width: "70%", fontSize: "16px", textAlign: "center" }}
            placeholder={t("enterName")}
          />
        </Form.Item>

        <Form.Item
          name="email"
          label={<span style={{ fontSize: "18px", fontWeight: "bold" }}>{t("email")}</span>}
        >
          <Input
            style={{ width: "70%", fontSize: "16px", textAlign: "center" }}
            placeholder={t("enterEmail")}
          />
        </Form.Item>

        <Form.Item
          name="phone_number"
          label={<span style={{ fontSize: "18px", fontWeight: "bold" }}>{t("phone")}</span>}
        >
          <Input
            style={{ width: "70%", fontSize: "16px", textAlign: "center" }}
            placeholder={t("enterPhone")}
          />
        </Form.Item>

        <Form.Item
          name="type"
          label={<span style={{ fontSize: "18px", fontWeight: "bold" }}>{t("type")}</span>}
        >
          <Select
            style={{ width: "40%", textAlign: "left", fontSize: "16px" }}
            placeholder={t("selectType")}
          >
            <Option value="Company">{t("company")}</Option>
            <Option value="Individual">{t("individual")}</Option>
            <Option value="Organization">{t("organization")}</Option>
          </Select>
        </Form.Item>

        <Form.Item label=".">
          <Button
            type="primary"
            htmlType="submit"
            style={{
              backgroundColor: "green",
              borderColor: "green",
              fontSize: "16px",
            }}
          >
            {t("submit")}
          </Button>
          <span style={{ margin: "0 8px" }}></span>
          <Button
            type="primary"
            danger
            onClick={() => form.resetFields()}
            style={{
              backgroundColor: "blue",
              borderColor: "blue",
              fontSize: "16px",
            }}
          >
            {t("reset")}
          </Button>
          <span style={{ margin: "0 8px" }}></span>
          <Button
            style={{
              backgroundColor: "red",
              borderColor: "red",
              fontSize: "16px",
            }}
            type="primary"
            danger
            onClick={() => (window.location.href = "/GetCustomer")}
          >
            {t("cancel")}
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default AddCustomer;
